/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frail_Fun_Tortoise_LendInputs */

const fr_frail_fun_tortoise_lend = /** @type {(inputs: Frail_Fun_Tortoise_LendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer par abonnement`)
};

/**

* @param {Frail_Fun_Tortoise_LendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const frail_fun_tortoise_lend = /** @type {((inputs?: Frail_Fun_Tortoise_LendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frail_Fun_Tortoise_LendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_frail_fun_tortoise_lend(inputs)
});